import { Direct } from './Direct';
export function isLinkDirect(link) {
    return link !== null && typeof link === 'object' && link instanceof Direct;
}
export {
    isLinkDirect as isDirect
};
export default isLinkDirect;    //# sourceMappingURL=isDirect.js.map
